import React from 'react';
import classNames from 'classnames';

import css from './IconCheckMark.module.css';

const SIZE_SMALL = 'small';
const SIZE_BIG = 'big';

/**
 * Checkmark icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @param {'big' | 'small'} props.size
 * @returns {JSX.Element} SVG icon
 */
const IconCheckmark = props => {
  const { rootClassName, className, size = SIZE_BIG } = props;
  const classes = classNames(rootClassName || css.root, className);
  if (size === SIZE_SMALL) {
    return (
     
<svg className={classes} width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.995 2.88232C12.3368 3.22412 12.3368 3.7792 11.995 4.121L4.99502 11.121C4.65322 11.4628 4.09814 11.4628 3.75635 11.121L0.256348 7.621C-0.0854492 7.2792 -0.0854492 6.72412 0.256348 6.38232C0.598145 6.04053 1.15322 6.04053 1.49502 6.38232L4.37705 9.26162L10.7591 2.88232C11.1009 2.54053 11.656 2.54053 11.9978 2.88232H11.995Z" fill="#A324F5"/>
</svg>

    );
  } else if (size === SIZE_BIG) {
    return (
      <svg className={classes} strokeWidth="2" xmlns="http://www.w3.org/2000/svg" role="none">
        <path d="M22.6 1.2c-.4-.3-1-.2-1.3.2L7.8 19l-5.2-5c-.4-.4-1-.4-1.3 0-.4.3-.4.8 0 1l6 5.6.6.2s.2 0 .4-.4l14.3-18c.3-.5.2-1-.2-1" />
      </svg>
    );
  }
};

export default IconCheckmark;
